import App from './App.svelte';
import { isDevelopment } from './utils/env';
import logger from './utils/logger';
logger.init();
document.title = `The Window${isDevelopment() ? ' - Dev' : ''}`;
const app = new App({
    target: document.body,
});
export default app;
